import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DefaultDropdownItem from './DefaultDropdownItem';

const Wrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Container = styled.tbody``;

class DefaultDropdownItems extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        label: PropTypes.string.isRequired
      })
    ),
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: null,
    items: [],
    onChange: null
  };

  onChange = value => {
    if (!this.props.onChange) return;
    this.props.onChange(value);
  };

  render() {
    return (
      <Wrapper>
        <Container>
          {this.props.items.map((item, i) => (
            <DefaultDropdownItem
              key={`${item.value}_${i}`}
              value={this.props.value}
              item={item}
              onChange={this.onChange}
            />
          ))}
        </Container>
      </Wrapper>
    );
  }
}

export default DefaultDropdownItems;



// WEBPACK FOOTER //
// ./src/components/units/Dropdown/DefaultDropdownItems/DefaultDropdownItems.js